import React, { useCallback, useState } from "react";
import "./style.css";
import { debounce } from "services/debounce/debounce";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface InputProps {
  type?: string;
  id?: string;
  className?: string;
  label?: string;
  value?: any;
  onChange?: any;
  name?: string;
  placeholder?: string;
  setFilter?: any;
}

const CustomInput = ({
  type = "text",
  id,
  className,
  label,
  value,
  onChange,
  name = "search",
  placeholder = "Filter",
  setFilter,
}: InputProps) => {
  const [query, setQuery] = useState(value);
  const { t } = useTranslation();

  const changeHandler = (event: any) => {
    const { value, name } = event.target;
    setFilter((prev: any) => ({ ...prev, [name]: value }));
    // toast.success("success search");
    // console.log(event.target.value)
    // setQuery(event.target.value);
    // onChange({
    //     target: {
    //         value: event.target.value,
    //         name: name
    //     }
    // })
  };
  const debouncedChangeHandler = useCallback(debounce(changeHandler, 300), []);
  return (
    <div className={`custom-input-group ${className}`}>
      {label && <div className={"input-label"}>{label}</div>}
      <input
        placeholder={t([placeholder])}
        defaultValue={query}
        type={type}
        id={id}
        name={name}
        className={`custom-input-all`}
        onChange={debouncedChangeHandler}
        autoComplete="off"
      />
    </div>
  );
};

export default CustomInput;
